function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useLayoutEffect } from 'react';
import { makeVar } from '@apollo/client';
/**
 * A hook that will detect if there is a scrollbar will be added to the viewport and
 * will add its width value as a `--global-scrollbar-width` custom property to the body element,
 * which can be used to calculate the full width of the viewport.
 */
// Check if the browser will add a scrollbar to the viewport

var getScrollBarWidth = function getScrollBarWidth() {
  var innerElement = document.createElement('div');
  innerElement.style.cssText = 'width:100%;height:200px';
  var outerElement = document.createElement('div');
  outerElement.style.cssText = 'position:absolute;top:-50px;left:0px;visibility:hidden;width:50px;height:50px;overflow:hidden';
  outerElement.appendChild(innerElement);
  document.body.appendChild(outerElement);
  var widthWithoutScroll = innerElement.offsetWidth;
  outerElement.style.overflow = 'scroll';
  var widthWithScroll = innerElement.offsetWidth;
  if (widthWithoutScroll === widthWithScroll) widthWithScroll = innerElement.clientWidth;
  document.body.removeChild(outerElement);
  return widthWithoutScroll - widthWithScroll;
}; // Watching for body height changes, and setting custom property with scrollbar width, when scrollbar is present.


var createObserver = function createObserver(scrollBarWidth) {
  return new globalThis.ResizeObserver(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;

        if (entry.target.scrollHeight > globalThis.innerHeight) {
          entry.target.style.setProperty('--global-scrollbar-width', "".concat(scrollBarWidth, "px"));
        } else {
          entry.target.style.setProperty('--global-scrollbar-width', '0px');
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}; // Using Apollo reactive var to store observer status, in order to add observer only once.


var isObserverActive = makeVar(false);
export var useDetectScrollWidth = function useDetectScrollWidth() {
  useLayoutEffect(function () {
    if (isObserverActive()) {
      return;
    }

    var scrollBarWidth = getScrollBarWidth();
    var observer = typeof globalThis.ResizeObserver !== 'undefined' && scrollBarWidth !== 0 ? createObserver(scrollBarWidth) : null;

    if (observer) {
      observer.observe(document.body);
      isObserverActive(true);
    }

    return function () {
      if (observer) {
        observer.disconnect();
        document.body.style.removeProperty('--global-scrollbar-width');
        isObserverActive(false);
      }
    };
  }, []);
};